<div class="filter-sort-container">
  <div class="filter-block flex flex-row flex-wrap gap-x-4 w-full">
    <app-filter-by-project
      [projectFilter]="projectFilter"
      (filterByProjectCallbackFunction)="projectChangeCallbackFunction($event)">

    </app-filter-by-project>

    <app-thingie-sort (callbackFunction)="sortsChangeCallbackFunction($event)"></app-thingie-sort>

    <app-pagination-filter-page-size
      [pageSizes] = "[4,8,16,32,64,128]"
      [selectedPageSize]="pageSize"
      (callbackFunction)="paginationPageSizeCallbackFunction($event)">
    </app-pagination-filter-page-size>

    <mat-slide-toggle
      data-cy="dashboard__cards__group_by_experiment_toggle"
      [checked]="groupByExperimentChecked"
      (change)="groupByExperimentChange($event)"
      class="mb-2 mt-3 ml-auto"
      >
      Group by experiment
    </mat-slide-toggle>
  </div>
</div>

<!-- Skeleton elements shown while loading -->
@if (thingies === undefined) {
  <div class="flex flex-row flex-wrap skeleton gap-3 content-start">
    @for (plot of skeletonRange; track plot) {
      <div class="dash">
        <mat-card class="mat-elevation-z4">
          <mat-card-header>
            <ion-skeleton-text animated></ion-skeleton-text>
          </mat-card-header>
          <mat-card-content class="mat-mdc-card-content">
            <ion-skeleton-text animated></ion-skeleton-text>
            <ion-skeleton-text animated></ion-skeleton-text>
            <ion-skeleton-text animated></ion-skeleton-text>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
}

<!-- The actual card list container shown after loading finished -->
@if(thingies !== undefined) {
  <div class="pb-3">
    <div class="flex flex-row flex-wrap content-start gap-6">
      <app-thingie-card-list
        [cards]="cards"
        [selectedCards]="shownCards"
        idPrefix="card-view"
        (selectedStackCard)="handleCardNameClick($event)">
      </app-thingie-card-list>
    </div>
  </div>
}

@if (shownCards.length === 0 && thingies.length === 0 && loadingData === false) {
  <div class="empty-tab-wrapper">
    <div class="empty-tab-info">
      <div class="text-col">
        <div>
          <h1>
            Sorry, no replicates matching the current selection!
          </h1>
          <p>
            You could check out other states, search for your replicate via search option or
            <a
              [routerLink]="[urls.route.thingieCreate]"
              [matTooltip]="'Create'"
              >
              <span>create new experiment.</span>
            </a>
          </p>
        </div>
      </div>
      <div class="empty-tab-img"></div>
    </div>
  </div>
}
